import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { OptInBrowserObservability } from './observability';
import { runtimeConfig } from './runtime-config';

const observability = new OptInBrowserObservability(runtimeConfig.telemetryEnabled);
export class RuntimeErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean; incidentId: string }
> {
  override state = { failed: false, incidentId: '' };
  static getDerivedStateFromError() {
    return { failed: true, incidentId: crypto.randomUUID() };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    observability.capture({
      level: 'error',
      code: 'UI_UNHANDLED',
      message: 'Unhandled UI error',
      context: { incidentId: this.state.incidentId, componentStack: info.componentStack ?? '' },
    });
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="runtime-failure" role="alert">
        <AlertTriangle size={24} />
        <h1>화면을 불러오지 못했습니다</h1>
        <p>입력한 내용은 다시 제출하지 말고 새로고침 후 상태를 확인하세요.</p>
        <small>오류 번호 {this.state.incidentId}</small>
        <button onClick={() => window.location.reload()}>새로고침</button>
      </main>
    );
  }
}
